import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudBaseService } from '../crud.service';
import { Observable } from 'rxjs';
import { omit } from 'lodash';
import { map } from 'rxjs/operators';
import { Payout, RefundPayload } from '../models';

@Injectable()
export class RefundService extends CrudBaseService<Payout> {
    constructor(httpClient: HttpClient) {
        super('/refund', httpClient);
    }

    refundDeposit(data: RefundPayload, gatewayId: string): Observable<any> {
        return this.httpClient
            .post<RefundPayload>(`${this.basePath}/${gatewayId}`, {
                data: omit(data)
            })
            .pipe(map((res: any) => res.data));
    }

    refundBrgCCDeposit(data: RefundPayload): Observable<any> {
        return this.httpClient
            .post<RefundPayload>(`${this.basePath}/brg_cc`, {
                data: omit(data)
            })
            .pipe(map((res: any) => res.data));
    }
}
